import { baseURL, httpClient } from '@/utils/http-client';
import { UploadSource } from '@/types/common';
class VideoService {
    httpClient;
    // private abortController:AbortController;
    constructor() {
        this.httpClient = httpClient;
    }
    formatObject(video) {
        let source = '';
        if (video.url && video.source == 'youtube') {
            source = 'youtube';
        }
        else if (video.name.endsWith('.mp4') && video.url == '') {
            source = 'stream';
        }
        else {
            source = video?.source;
        }
        return {
            id: video.id,
            //isVimeo: false,
            title: video.name,
            url: video.file?.publicUrl,
            dateAdded: video?.createdAt,
            preview: video.preview?.publicUrl,
            metadata: video?.metadata,
            compiled: video.compiled || null,
            transcription: video?.transcription || null,
            source: source,
            quality: video?.format,
            youtubeUrl: video?.url
        };
    }
    async getQueuedList() {
        const response = await this.httpClient.get('/video/queued/list');
        return response.data;
    }
    async getVideoTranscriptionAssemblyAIId(videoId) {
        const first_response = await this.httpClient.get('/video/transcriptions/aai/' + videoId);
        return first_response.data;
    }
    async getVideoList(page, limit) {
        if (!page || !limit) {
            const response = await this.httpClient.get('/video');
            return response.data.map((video) => {
                return this.formatObject(video);
            });
        }
        else {
            const response = await this.httpClient.get('/video', {
                params: {
                    page: page,
                    limit: limit
                }
            });
            return response.data.items.map((video) => {
                return this.formatObject(video);
            });
        }
    }
    async uploadYoutubeVideo({ url, language, format, source, videoId, options }) {
        return await this.httpClient
            .post('/video/youtube', { url, language, format, source, videoId, options })
            .then(response => {
            return this.formatObject(response.data);
        })
            .catch(error => {
            if (error.response) {
                const { statusCode, message } = error.response.data;
                if (statusCode < 500) {
                    throw new Error('Something went wrong. Please try again.');
                }
                throw new Error(message);
            }
        });
    }
    async updateVideoName(videoid, name) {
        return await this.httpClient.put(`/video/${videoid}`, { name }, {
            responseType: 'json'
        });
    }
    async downloadTranscription(id) {
        return await this.httpClient.get(`/video/transcription/${id}`, {
            responseType: 'json'
        });
    }
    async uploadVideo(
    // formData: FormData,
    data, uploadProgressCallback) {
        // const response = await this.httpClient.post("/video", formData, {
        //   maxBodyLength: Infinity,
        //   maxContentLength: Infinity,
        //   onUploadProgress: uploadProgressCallback,
        // });
        // return this.formatObject(response.data);
    }
    async getVideoUploadStatus(id) {
        return new EventSource(`${baseURL}/events/video/upload/${id}`);
    }
    async getVideo(id, withTranscription = true) {
        const response = await this.httpClient.get(`/video/${id}`, {
            params: {
                full: withTranscription
            }
        });
        return this.formatObject(response.data);
    }
    async getSignedUrl() {
        const response = await this.httpClient.get('/video/upload/signedurl');
        return response.data;
    }
    async saveSignedUrl({ source = UploadSource.LOCAL, ...payload }) {
        const response = await this.httpClient.post('/video/upload/signedurl', {
            ...payload,
            source,
            options: {
                ...payload.options,
                reencode: payload.options?.reencode
            }
        });
        return response.data;
    }
    async deleteVideo(id) {
        return await this.httpClient.delete(`/video/${id}`);
    }
    async fetchFormats(url, source) {
        const payload = {
            url,
            source
        };
        const response = await this.httpClient.post('/video/formats', payload);
        return response.data.map((format) => {
            let selected = response.data[0] === format ? true : false;
            return {
                label: format.label + 'p',
                value: format.label,
                available: true,
                selected: selected,
                show: true
            };
        });
    }
    async fetchVideoPreview(url, source) {
        const payload = {
            url,
            source
        };
        const response = await this.httpClient.post('/video/preview', payload);
        return response.data;
    }
}
export default VideoService;
